__turbopack_context__.v({
  "body": "careers-intro-module-scss-module__DvMVJq__body",
  "cta": "careers-intro-module-scss-module__DvMVJq__cta",
  "eyebrow": "careers-intro-module-scss-module__DvMVJq__eyebrow",
  "heading": "careers-intro-module-scss-module__DvMVJq__heading",
  "intro": "careers-intro-module-scss-module__DvMVJq__intro",
});
